import React from 'react';
import { Button, SHAPE } from 'baseui/button';
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox';
import { FormControl } from 'baseui/form-control';
import { Search } from 'baseui/icon';
import { Input } from 'baseui/input';
import { DIVIDER, SIZE as TABLE_SIZE, Table } from 'baseui/table-semantic';
import { TASK_STATES_VIEW_TABLE_COLUMNS, TASK_VIEW_TABLE_COLUMNS } from '../../consts/task';
import { useGetTasksInBatch } from '../../hooks/use-get-tasks-in-batch';
import type { Task } from '../../types/task';
import ErrorComponent from './error';
import { TableInnerContainer, TableOuterContainer } from './TableContainer';
const groupTasksByGlobalTaskId = (tasks: Task[]) => {
  const groups: {
    [e: string]: Task;
  } = {};
  const sortedTasks = [...tasks].sort((a, b) => a.id - b.id);
  sortedTasks.forEach(task => {
    if (!groups[task.globalTaskId]) {
      groups[task.globalTaskId] = {
        ...task
      };
    }
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].metadata = {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      ...groups[task.globalTaskId].metadata,
      ...task.metadata
    };
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].assignedTo = task.assignedTo || 'Unassigned';
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].createdAt = task.createdAt;
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].updatedAt = task.updatedAt;
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].state = task.state;
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    groups[task.globalTaskId].status = task.status;
  });
  return Object.values(groups);
};
const formatElapsedTime = (seconds: string | undefined) => {
  const numericSeconds = Number(seconds);
  if (seconds === undefined || !Number.isFinite(numericSeconds) || numericSeconds < 0) {
    return '-';
  }
  const totalSeconds = Math.floor(numericSeconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const remainingSeconds = totalSeconds % 60;
  const parts = [hours ? `${hours}h` : '', minutes ? `${minutes}m` : '', remainingSeconds ? `${remainingSeconds}s` : ''];
  return parts.filter(Boolean).join(' ') || '0s';
};
const getAggregatedTaskRow = (task: Task) => [task.globalTaskId, task.name, task.state, task.status, task.assignedTo || 'Unassigned', task.metadata?.['duration'], task.metadata?.['frameRate'], task.metadata?.['totalFrames'], new Date(task.createdAt).toLocaleString(), task.updatedAt ? new Date(task.updatedAt).toLocaleString() : new Date(task.createdAt).toLocaleString()];
const getTaskStateRow = (task: Task) => [task.id, task.globalTaskId, task.name, task.state, task.status, task.assignedTo || 'Unassigned', formatElapsedTime(task.metadata?.['time_on_paused']), formatElapsedTime(task.metadata?.['time_on_assigned']), task.metadata?.['auto_pause_count'] || '-', new Date(task.createdAt).toLocaleString(), task.updatedAt ? new Date(task.updatedAt).toLocaleString() : new Date(task.createdAt).toLocaleString()];
const sortTasksByGlobalTaskIdAndId = (tasks: Task[]) => [...tasks].sort((firstTask, secondTask) => {
  const globalTaskIdOrder = firstTask.globalTaskId.localeCompare(secondTask.globalTaskId);
  return globalTaskIdOrder || firstTask.id - secondTask.id;
});
const BatchTasks = () => {
  const [batchId, setBatchId] = React.useState<number>();
  const [showAllTasks, setShowAllTasks] = React.useState(false);
  const [shouldFetch, setShouldFetch] = React.useState(false);
  const {
    data: tasks,
    isLoading,
    isError,
    error
  } = useGetTasksInBatch(batchId, shouldFetch);
  return <TableOuterContainer>
      <FormControl label="Batch Id">
        <Input value={batchId} onKeyDown={e => {
        if (e.key === 'Enter') {
          setShouldFetch(true);
        }
      }} onChange={e => {
        setShouldFetch(false);
        setBatchId(+e.currentTarget.value);
      }} placeholder="Enter batch id" endEnhancer={<Button shape={SHAPE.circle} size="compact" kind="secondary">
              <Search onClick={() => setShouldFetch(true)} />{' '}
            </Button>} type="number" min={0} step={1} />
      </FormControl>
      <Checkbox checked={showAllTasks} onChange={event => setShowAllTasks(event.target.checked)} checkmarkType={STYLE_TYPE.toggle_round} labelPlacement={LABEL_PLACEMENT.right}>
        Show all task states
      </Checkbox>
      <TableInnerContainer>
        {isError && <ErrorComponent message={error?.message || 'Something went wrong fetching tasks'} />}
        {tasks && !isError && <Table isLoading={isLoading} emptyMessage={tasks.length === 0 ? 'Batch not found' : ''} size={TABLE_SIZE.compact} divider={DIVIDER.grid} columns={showAllTasks ? TASK_STATES_VIEW_TABLE_COLUMNS : TASK_VIEW_TABLE_COLUMNS} data={showAllTasks ? sortTasksByGlobalTaskIdAndId(tasks).map(getTaskStateRow) : groupTasksByGlobalTaskId(tasks).map(getAggregatedTaskRow)} />}
      </TableInnerContainer>
    </TableOuterContainer>;
};
export default BatchTasks;